@import '../../../constants/spacing.module.less';

.upsell-icon,
.upsell-icon-right {
  margin-right: @space-8;
  height: @space-16;
  width: @space-16;
}

.upsell-icon-right {
  margin-left: @space-8;
}
